/* eslint-disable import/no-anonymous-default-export */
import base from './base';

export default {
	html: {
		width: '100%',
		height: '100%',
		fontSize: '16px/1.5',
	},
	body: {
		// Airchain background: a quiet dark gradient plus a faint repeating
		// hairline rhythm echoing the caption-stack mark (see Header.js's
		// Logo), replacing the old datarhei "universe" stock space photo --
		// that image paired with the old rocket-ship logo/"blast off"
		// copy, neither of which exist in this build anymore.
		backgroundColor: '#0b0f13',
		backgroundImage: `radial-gradient(ellipse 1400px 900px at 20% 0%, rgba(53, 214, 232, 0.06), rgba(0, 0, 0, 0) 60%),
			repeating-linear-gradient(0deg, rgba(53, 214, 232, 0.02) 0px, rgba(53, 214, 232, 0.02) 1px, rgba(0, 0, 0, 0) 1px, rgba(0, 0, 0, 0) 96px)`,
		backgroundAttachment: 'fixed, fixed',
		backgroundRepeat: 'no-repeat, repeat',
		overflowX: 'hidden',
		overflowY: 'scroll',
	},
	code: {
		fontFamily: 'soure-code-pro, monospace',
	},
	textarea: {
		width: '100%',
		backgroundColor: base.palette.background.modalbox,
		fontFamily:
			'Consolas, "Andale Mono WT", "Andale Mono", "Lucida Console", "Lucida Sans Typewriter", "DejaVu Sans Mono", "Bitstream Vera Sans Mono", "Liberation Mono", "Nimbus Mono L", Monaco, "Courier New", Courier, monospace',
		fontSize: 14,
		whiteSpace: 'pre',
		overflow: 'auto',
		color: base.palette.text.primary,
		border: '0',
		resize: 'none',
		wordWrap: 'inherit',
		wordBreak: 'inherit',
		overflowWrap: 'normal',
	},
	'*:focus': {
		outline: 'none',
	},
	'::-webkit-scrollbar': {
		width: 6,
		height: 6,
	},
	'::-webkit-scrollbar:vertical': {
		width: 6,
	},
	'::-webkit-scrollbar:horizontal': {
		height: 6,
	},
	'::-webkit-scrollbar-thumb': {
		borderRadius: 4,
		color: base.palette.background.footer1,
		backgroundColor: base.palette.background.footer1,
	},
	'::-webkit-scrollbar-track': {
		backgroundColor: 'transparent',
		borderRadius: 8,
	},
	'::-webkit-scrollbar-corner': {
		background: 'transparent',
	},
	// firefox
	'@-moz-document url-prefix(http://),url-prefix(https://)': {
		scrollbar: {
			MozAppearance: 'none !important',
			background: `${base.palette.background.footer1}!important`,
		},
		'thumb,scrollbarbutton': {
			MozAppearance: 'none !important',
			backgroundColor: 'transparent !important',
		},
		'thumb:hover,scrollbarbutton:hover': {
			MozAppearance: 'none !important',
			backgroundColor: 'transparent !important',
		},
		scrollbarbutton: {
			display: 'none !important',
		},
		'scrollbar[orient="vertical"]': {
			minWidth: '6px !important',
		},
	},
	// Extend build in Player
	// -> removes black bottom line
	'[data-player]': {
		margin: '2px -2px 2px -2px',
	},
};
